import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FundamentalChartModule } from '../fundamental-chart/fundamental-chart.module';
import * as i0 from "@angular/core";
export class PerformanceChartModule {
}
PerformanceChartModule.ɵfac = function PerformanceChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PerformanceChartModule)(); };
PerformanceChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerformanceChartModule });
PerformanceChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, BrowserModule, FundamentalChartModule] });
